import { catchError, concatMap, filter, switchMap } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'
import { concat, from, of } from 'rxjs'
import { toast } from 'react-toastify'
import {
  getUserRequest,
  loginRequest,
  loginSuccess,
  loginFailure,
  login2FARequest,
  login2FASuccess,
  login2FAFailure,
  logoutRequest,
  logoutSuccess,
  logoutFailure,
  unsetAuthToken,
  unsetAuth2FAToken,
} from '../actions'
import { RootEpic } from '../types'
import { deleteCookie } from '../../utils'

export const loginUserEpic: RootEpic = (action$, _, { loginUser }) => {
  return action$.pipe(
    filter(isActionOf(loginRequest)),
    switchMap(({ payload }) =>
      from(loginUser(payload)).pipe(
        concatMap((response) => {
          if (response.accessToken) {
            return concat(of(loginSuccess(response)), of(getUserRequest({ accessToken: response.accessToken })))
          }
          return of(loginSuccess(response))
        }),
        catchError((message) => {
          toast.error('Login failed. User name and/or password is incorrect.')
          return of(loginFailure(message))
        }),
      ),
    ),
  )
}

export const login2FAUserEpic: RootEpic = (action$, state$, { login2FAUser }) => {
  return action$.pipe(
    filter(isActionOf(login2FARequest)),
    switchMap(({ payload }) =>
      from(login2FAUser({ token: state$.value.app.auth2FAToken as string, ...payload })).pipe(
        concatMap((response) => {
          if (response.accessToken) {
            return concat(
              of(login2FASuccess(response)),
              of(getUserRequest({ accessToken: response.accessToken, after2fa: true })),
            )
          }
          return of(login2FASuccess(response))
        }),
        catchError((message) => {
          toast.error('Login failed. Two-factor authentication is incorrect.')
          return of(login2FAFailure(message))
        }),
      ),
    ),
  )
}

export const logoutUserEpic: RootEpic = (action$, state$, { logoutUser, appContext }) => {
  return action$.pipe(
    filter(isActionOf(logoutRequest)),
    switchMap(() =>
      from(logoutUser({ token: state$.value.app.authToken as string })).pipe(
        concatMap((response) => {
          const ctx = appContext()
          ctx.removeAuthTokenFromStore()
          ctx.removeAuth2FAFromStore()
          ctx.removeUserNameFromStore()
          ctx.removeClientIdFromStore()
          ctx.removeClientSecretFromStore()
          ctx.removeUserIdSfFromStore()
          ctx.removeUserRoleFromStore()
          deleteCookie('token')
          toast.success('Logout is successful.')
          return concat(of(logoutSuccess(response)), of(unsetAuthToken()), of(unsetAuth2FAToken()))
        }),
        catchError((message) => {
          toast.error(message)
          return of(logoutFailure(message))
        }),
      ),
    ),
  )
}

export default [loginUserEpic, login2FAUserEpic, logoutUserEpic]
